export const validationFormat = (value, targetCount = 3, minLength = 9, maxLength = 20) => {
  const str = `${value || ''}`;
  const strLength = str.length;
  if (strLength < minLength || strLength > maxLength) return false;
  if (/[^0-9a-zA-Z]/.test(str)) return false;
  const numberReg = /[0-9]/g;
  const lowerCaseLettersReg = /[a-z]/g;
  const uppercaseLetterReg = /[A-Z]/g;
  // const specialCharactersReg = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·！￥…（）—《》？：“”【】、；‘，。]/g;
  const count = [numberReg, lowerCaseLettersReg, uppercaseLetterReg].reduce((total, reg) => total += str.match(reg)?.length ? 1 : 0, 0);
  return count >= targetCount;
};
export default {
  validationFormat,
};
